<!-- 조직관리 > 회원관리 상세 -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="form-group col-ty">
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.id')}}<span class="imp">*</span></div>
          <div class="row">
            <c-Input v-bind="inpId" v-model="memberId" :name="'memberId'" class="size01"/>
          </div>
        </div>
        <div class="form-row">
          <div class="txt-tit">{{t('message.name')}}<span class="imp">*</span></div>
          <div class="row">
            <c-Input :placeholder="t('message.enterName')" v-model="memberName" :name="'memberName'" class="size01"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.password')}}<span class="imp">*</span></div>
          <div class="row">
            <c-Input v-bind="inpPw" v-model="password" :name="'password'" class="size01"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.department')}}<span class="imp">*</span></div>
          <div class="row">
            <c-btn01
              v-bind="deptName?btnPartChange:btnPartInsert"
              class="sm"
              @click="openPopup('dept')"/>
            <div class="txt02">{{deptName}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.position')}}<span class="imp">*</span></div>
          <div class="row">
            <c-btn01
              v-bind="posName?btnPartChange:btnPartInsert"
              class="sm"
              @click="openPopup('pos')"/>
            <div class="txt02">{{posName}}</div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.phoneNumber')}}</div>
          <div class="row">
            <c-Input v-bind="inpTel" v-model="telNo" :name="'telNo'" class="size01"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.email')}}</div>
          <div class="row">
            <c-Input v-bind="inpEmail" v-model="email"  :name="'email'" class="size01"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            <c-tooltip v-bind="useTooltip"/>
            {{t('message.usageStatus')}}<span class="imp">*</span>
          </div>
          <div class="row">
            <v-switch v-model="useYn" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            <c-tooltip v-bind="adminTooltip"/>
            {{t('message.isAdmin')}}<span class="imp">*</span>
          </div>
          <div class="row">
            <v-switch v-model="adminYn" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            <c-tooltip v-bind="leaderTooltip"/>
            {{t('message.isOrgLeader')}}<span class="imp">*</span>
          </div>
          <div class="row">
            <v-switch v-model="headYn" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.isShiftWorker')}}<span class="imp">*</span></div>
          <div class="row">
            <v-switch v-model="shiftYn" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <div class="form-row" v-if="shiftYn=='Y'">
          <div class="txt-tit">{{t('message.shiftWork')}}</div>
          <div class="row">
            <Select v-bind="shiftSelect" v-model="shiftIdx"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            <c-tooltip v-bind="pwChangeTooltip"/>
            {{t('message.isPasswordRequired')}}<span class="imp">*</span>
          </div>
          <div class="row">
            <v-switch v-model="passwordYn" inset hide-details true-value="Y" false-value="N"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">
            {{t('message.changeInfo')}}
          </div>
          <div class="row">
            <c-btnText01 :btnText="historyCnt" @click="showDialog"/>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn-group">
      <div class="wl">
        <c-btnLine01 v-bind="btnPageList" @click.stop="onClickGoList()"/>
      </div>
      <div class="wr">
        <c-btn02 v-bind="btnPageDel" @click="dialogPageDelModel=true"/>
        <c-btn01 v-bind="btnPageModify" @click="validateAll"/>
      </div>
    </div>
  </div>
  <!--부서-->
  <DialogDept
    v-model="deptDialogModel"
    @close="closePopup"
    @confirm="closePopup"/>
  <!--변경정보-->
  <c-dialog v-model="dialogChangeNumModel"
            v-bind="dialogChangeNumBind"
            :dialogText="historyDialogText"
            @close="dialogChangeNumModel=false"
  />
  <!--삭제-->
  <c-dialog v-model="dialogPageDelModel"
            v-bind="dialogPageDelBind"
            @close="dialogPageDelModel=false"
            @confirm="confirmDelete"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>
<style lang="scss" >
</style>
<script setup lang="ts">
import { ref } from 'vue'
import MemberService from "@/services/member.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import {Form, useForm} from "vee-validate";
import * as yup from "yup";
import _ from 'lodash';
import dayjs from "dayjs";
import LogService from "@/services/log.service";
import {useRoute} from "vue-router";
import CompanyService from "@/services/company.service";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//validation schema
const schema = yup.object().shape({
  //https://stackoverflow.com/questions/62950190/how-to-set-dynamic-error-messages-in-yup-async-validation
  memberId: yup.string().required(() => t('message.requiredField')),
  //password: yup.string().required(() => t('message.requiredField')),
  //telNo: yup.number().typeError(() => t('message.onlyNumbersAllowed')).required(() => t('message.requiredField')),
  //email: yup.string().email('형식이 맞지않습니다.').required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
const deptDialogModel = ref(false)
const dialogChangeNumModel = ref(false)
const viewIdx = route.params.idx?route.params.idx:''
const memberId = ref('')
const memberName = ref('')
const password = ref('')
const deptIdx = ref('')
const deptName = ref('')
const posIdx = ref('')
const posName = ref('')
const telNo = ref('')
const email = ref('')
const useYn = ref('N')
const adminYn = ref('N')
const headYn = ref('N')
const shiftYn = ref('N')
const shiftSelect = ref({items:[{name: t('message.shiftWork'), value: ''}]})
const shiftIdx = ref('')
const passwordYn = ref('N')
const historyCnt = ref(0)
const historyDialogText = ref('')

//ui
const dialogChangeNumBind = {
  dialogTit: t('message.changeInfoFormat'),
  dialogText: '',
  btn1Text: t('message.confirm'),
  btn1Show: true,
  width:120
}
const dialogPageDelModel = ref(false)
const dialogPageDelBind = {
  dialogTit: t('message.delete'),
  dialogText: t('message.deleteConfirmation'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
  width:120
}
const inpId = {
  placeholder: t('message.enterUserId')
}
const inpPw = {
  placeholder: t('message.enterPassword'),
  type:'password'
}
const inpTel = {
  placeholder: t('message.enterPhoneNumber'),
  type:'tel'
}
const inpEmail = {
  placeholder: t('message.enterEmail'),
  type:'email'
}
const btnPartChange = {
  btnText: t('message.update'),
  btnShow: true,
  btnType: 'button'
}
const btnPartInsert = {
  btnText: t('message.select'),
  btnShow: true,
  btnType: 'button'
}
const useTooltip = {
  TooltipText: t('message.toggleUserActivation')
}
const adminTooltip = {
  TooltipText: t('message.companyAdminScope')
}
const leaderTooltip = {
  TooltipText: t('message.reportAutoSendPermission')
}
const pwChangeTooltip = {
  TooltipText: t('message.enableUserPasswordChange')
}
const btnPageList = {
  btnText: t('message.list'),
}
const btnPageDel = {
  btnText: t('message.delete'),
}
const btnPageModify = {
  btnText: t('message.registerOrUpdate'),
}

//hook
onMounted(() => {
  getData()
  if(!utils.isEmpty(viewIdx)) {
    let params = {
      idx: viewIdx
    }

    MemberService.getMember(params).then(
      (response:any) => {
        memberId.value = response.result.memberId
        memberName.value = response.result.memberName
        //password.value = response.result.password
        deptIdx.value = response.result.deptIdx
        posIdx.value = response.result.posIdx
        deptName.value = response.result.deptName
        posName.value = response.result.posName
        telNo.value = response.result.telNo
        email.value = response.result.email
        useYn.value = response.result.useYn
        adminYn.value = response.result.adminYn
        headYn.value = response.result.headYn
        shiftYn.value = response.result.shiftYn
        shiftIdx.value = response.result.shiftIdx==0?'':response.result.shiftIdx
        passwordYn.value = response.result.passwordYn
        historyCnt.value = response.result.historyCnt
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
})

//function
const validateAll = async () => {
  const result = await validate(); // 전체 필드 검증 실행
  if(result.valid)
    handleForm()
}

const handleForm=()=>{
  if(import.meta.env.MODE == 'development') {
    utils.movePage('/organizationalManagement/2/list')
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let params = {
      idx: viewIdx,
      companyIdx:companyIdx,
      memberId: memberId.value,
      memberName: memberName.value,
      password: password.value,
      deptIdx: deptIdx.value,
      posIdx: posIdx.value,
      deptName: deptName.value,
      posName: posName.value,
      telNo: telNo.value,
      email: email.value,
      useYn: useYn.value,
      adminYn: adminYn.value,
      headYn: headYn.value,
      shiftYn: shiftYn.value,
      shiftIdx: shiftIdx.value,
      passwordYn: passwordYn.value,
      clientIdx: localStorage.getItem('clientIdx')
    }

    MemberService.insertMember(params).then(
      (response:any) => {
        if(response.success)
          utils.movePage('/organizationalManagement/2/list')
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const getData=()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx: companyIdx,
  }

  CompanyService.getCompanyShiftList(params).then(
    (response) => {
      let shiftList = response.result
      _.forEach(shiftList, (item)=> {
        shiftSelect.value.items.push({name: item.shiftName, value: item.idx})
      })
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const openPopup=(type)=>{
  let companyIdx = localStorage.getItem('companyIdx')
  storeRef.popupIdx.value = companyIdx
  storeRef.popupType.value = type
  deptDialogModel.value = true
}

const closePopup=(type)=>{
  deptDialogModel.value=false
  if(type !== false) {
    console.log(type)
    let resultName = []
    let resultIdxs = []
    _.forEach(type, (obj, key)=> {
      resultName.push(obj.treeName)
      resultIdxs.push(obj.idx)
    });

    if(storeRef.popupType.value == 'dept'){
      deptName.value = resultName.join(',')
      deptIdx.value = resultIdxs.join(',')
    }
    else if(storeRef.popupType.value == 'pos'){
      posName.value = resultName.join(',')
      posIdx.value = resultIdxs.join(',')
    }
  }
}

const onClickGoList=()=>{
  utils.movePage('/organizationalManagement/2/list')
}

const showDialog=()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    tableType: 'member',
    parentIdx: viewIdx
  }
  LogService.getLogList(params).then(
    (response:any) => {
      let logContent = ''
      if(response.result.length > 0) {
        response.result.forEach((row)=> {
          logContent += `${row.changeLog} / ${row.memberId} / ${dayjs(row.regDate).format('YYYY-MM-DD HH:mm:ss')} <br>`
        });
      }

      if(logContent != '') {
        historyDialogText.value = utils.changeLogLanguage(logContent)
        dialogChangeNumModel.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const confirmDelete=async ()=>{
  let deleteArr = [viewIdx]
  let params = {
    companyIdx:localStorage.getItem('companyIdx'),
    memberArr: deleteArr,
  }
  try{
    const response = await MemberService.deleteMember(params)
    if(response.success) {
      snackText.value = 'success'
      snackbar.value = true

      setTimeout(() => {onClickGoList()}, 1000)
    }
    else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch (error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}
</script>

